var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVerticalDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 5 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0M4.5 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M2.5 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})));
export { SvgIconVerticalDots as ReactComponent };